<template>
  <div class="relative">
    <section
      :class="$style['content']"
      class="mt-10 pb-24"
    >
      <template v-if="waitingList">
        <h3 class="font-light text-l sm:text-xl sm:leading-xl md:text-2xl md:leading-xl lg:text-xxl leading-l lg:leading-xxl">
          ¡Gracias por tu interés en la revolución electrica de la Familia ID!
        </h3>

        <p class="text-base leading-xs md:text-m lg:leading-m mb-6 mt-4 md:mt-6 font-light">
          Cuando tengamos una plaza libre nos pondremos en contacto contigo
        </p>
      </template>

      <template v-else>
        <h3 class="font-bold text-l sm:text-xl sm:leading-xl md:text-2xl md:leading-xl lg:text-xxl leading-l lg:leading-xxl">
          ¡Bienvenid@, ya tienes tu entrada para la experiencia ID. Street!
        </h3>

        <p class="text-base leading-xs md:text-m lg:leading-m mb-6 mt-4 md:mt-6 font-light">
          Eres uno de los privilegiados en ver, tocar y descubrir la calle del futuro de Volkswagen.
        </p>
      </template>
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },

  props: {
    waitingList: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
  }
}
</script>

<style
  module
  lang="scss"
>
.content {
  @apply m-auto;
  padding: 80px 20px 0 20px;
  max-width: 1200px;
}

@media (min-width: 576px) {
  .content {
    padding-top: 100px;
  }
}
</style>
